import { render, staticRenderFns } from "./documents_management.vue?vue&type=template&id=45229e7f&scoped=true"
import script from "./documents_management.vue?vue&type=script&lang=js"
export * from "./documents_management.vue?vue&type=script&lang=js"
import style0 from "./documents_management.vue?vue&type=style&index=0&id=45229e7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45229e7f",
  null
  
)

export default component.exports